import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface ImpersonationLoginResponse extends BackendResponse {
  /** redirect url */
  item: string;
}

export interface ImpersonationLoginParameters extends NextApiParams {
  k: string;
  candidateId: number;
}

export const impersonationLogin = withNextApi<
  ImpersonationLoginResponse,
  ImpersonationLoginParameters
>("/auth/ImpersonationLogin", {
  method: "GET",
});
